import styled from 'styled-components'

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  gap: 2.4rem;

  .section-heading {
    display: flex;
    flex-direction: column;
    gap: 0.6rem;
  }

  h2 {
    font-size: clamp(2.6rem, 4vw, 3.2rem);
    letter-spacing: -0.03rem;
  }

  .eyebrow {
    text-transform: uppercase;
    letter-spacing: 0.18rem;
    color: var(--muted);
    font-weight: 600;
    font-size: 1.2rem;
  }

  .intro {
    max-width: 78ch;
    color: var(--muted);
    font-size: 1.7rem;
  }

  .info-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    gap: 1.8rem;
    margin-top: 0.5rem;
  }

  .info-card {
    background: var(--surface);
    border: 1px solid var(--border);
    border-radius: 18px;
    padding: 2.2rem;
    box-shadow: var(--shadow);
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
    min-height: 100%;

    h3 {
      font-size: 1.8rem;
      color: var(--accent);
      letter-spacing: 0.02rem;
    }

    p {
      color: var(--muted);
      font-size: 1.5rem;
      line-height: 1.6;
    }

    ul {
      display: grid;
      gap: 0.8rem;
      padding: 0;
      margin: 0;

      li {
        color: var(--muted);
        font-size: 1.5rem;
        line-height: 1.6;
      }
    }

    .item {
      display: grid;
      gap: 0.2rem;
      padding: 0.4rem 0;

      .title {
        font-weight: 700;
        font-size: 1.6rem;
        color: var(--text);
      }

      .meta {
        color: var(--muted);
      }

      .time,
      .detail {
        color: var(--muted);
        font-size: 1.4rem;
      }
    }
  }

  .skill-pills {
    display: flex;
    flex-wrap: wrap;
    gap: 0.8rem;
    margin-top: 0.4rem;
  }

  .pill {
    border: 1px solid var(--border);
    border-radius: 999px;
    padding: 0.85rem 1.6rem;
    font-weight: 600;
    color: var(--text);
    background: var(--pill-bg);
    letter-spacing: 0.02rem;
    transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;

    &:hover {
      background: var(--gradient);
      box-shadow: 0 10px 28px rgba(0, 0, 0, 0.25);
      transform: translateY(-1px);
    }
  }

  @media (max-width: 640px) {
    .info-grid {
      gap: 1.4rem;
    }
  }
`
